<template>
  <p-edit-skill v-if="$hasPermission('skills.read')" :name="name" />
  <p-not-found v-else />
</template>

<script>
import EditSkill from '@/components/skills/EditSkill.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    'p-edit-skill': EditSkill,
    'p-not-found': NotFound
  },
  props: {
    name: {
      type: String,
      default: null
    }
  }
};
</script>
